import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { EmailInput } from './email-input';

@Component({
  selector: 'app-email-input',
  templateUrl: './email-input.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class EmailInputComponent implements OnInit {
  @Input() disabled: boolean;
  @Input() value: string;
  @Input() placeholder = 'registration.emailLabel';
  @Output() onEmailChanged: EventEmitter<EmailInput> = new EventEmitter();
  @ViewChild('loginEmailInput', { static: true }) inputElement: any;
  public emailInput: EmailInput;

  ngOnInit() {
    this.emailInput = new EmailInput();
    this.emailInput.emailAddress = this.value;
  }

  public onInputChange() {
    // Update values
    this.emailInput.emailAddress = this.getValue();
    this.emailInput.isValid = this.isValid();

    // Trigger event
    this.onEmailChanged.emit(this.emailInput);
  }

  public isValid(): boolean {
    return this.getValue() && this.inputElement.valid;
  }

  private getValue(): string {
    return this.inputElement.value;
  }
}
